import React, { Component } from "react";
import FileUploader from "react-firebase-file-uploader";
import firebase from "./firebase";
import _ from "lodash";

let makeid = length => {
    var text = "";
    var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
};

const FileWidget = props => {
    return (
        <div>
            <div className="input-group mb-3">
                <div className="custom-file">
                    <FileUploader
                        className="custom-file-input"
                        required={props.required}
                        filename={file => {
                            return `${makeid(5)}-upload-${file.name.substr(
                                0,
                                25
                            )}`;
                        }}
                        id={props.id}
                        name={props.id}
                        storageRef={firebase.storage().ref(`${props.subID}/`)}
                        onUploadStart={props.handleUploadStart}
                        onUploadError={props.handleUploadError}
                        onUploadSuccess={props.handleUploadSuccess}
                        onProgress={props.handleProgress}
                    />
                    <label className="custom-file-label" htmlFor={props.id}>
                        Choose file
                    </label>
                </div>
            </div>
            <div className="progress">
                <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow={props.uploadProgress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: props.uploadProgress + "%" }}
                />
            </div>
        </div>
    );
};

class FieldFile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filePath: props.fieldConfig.value || "",
            uploadError: false,
            uploadInProgress: false,
            uploadProgress: 0,
            value: props.fieldConfig.value
        };

        this.handleProgress = this.handleProgress.bind(this);
        this.handleUploadError = this.handleUploadError.bind(this);
        this.handleUploadStart = this.handleUploadStart.bind(this);
        this.handleUploadSuccess = this.handleUploadSuccess.bind(this);
        this.resetUpload = this.resetUpload.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(this.state.value, nextProps.fieldConfig.value)) {
            this.setState({
                value: nextProps.fieldConfig.value,
                filePath: nextProps.fieldConfig.value
            });
        }
    }

    resetUpload() {
        this.setState({
            filePath: "",
            uploadInProgress: false,
            uploadProgress: 0
        });
    }

    handleUploadStart() {
        this.setState({ uploadInProgress: true });
    }

    handleProgress(num, task) {
        this.setState({ uploadProgress: parseInt(num, 10) });
    }

    handleUploadError(filename, data) {
        this.setState({ uploadError: true, uploadInProgress: false });
    }

    async handleUploadSuccess(filename, data) {
        console.log("uploadSuccess", data);
        let downloadURL = await data._ref.getDownloadURL();
        console.log(downloadURL);
        this.setState({
            filePath: downloadURL,
            uploadInProgress: false
        });
        this.props.fieldConfig.onChange({
            target: {
                name: this.props.fieldConfig.name,
                value: downloadURL,
                type: "input"
            },
            persist: () => {
                return true;
            }
        });
    }

    render() {
        let {
            fieldConfig,
            name,
            schema,
            subID,
            uiSchema,
            ...props
        } = this.props;
        let filename;

        if (this.state.filePath.length > 0) {
            let url = document.createElement("a");
            url.href = this.state.filePath;
            filename = url.pathname.substring(
                url.pathname.indexOf("-upload-") + 8
            );
        }

        return (
            <div>
                {this.state.filePath ? (
                    <div>
                        <p>
                            File uploaded:{" "}
                            <a href={this.state.filePath} target="_blank">
                                {filename}
                            </a>{" "}
                            <button
                                className="btn btn-light btn-sm"
                                onClick={this.resetUpload}
                            >
                                Upload new file?
                            </button>
                        </p>
                    </div>
                ) : (
                    <FileWidget
                        handleProgress={this.handleProgress}
                        handleUploadError={this.handleUploadError}
                        handleUploadStart={this.handleUploadStart}
                        handleUploadSuccess={this.handleUploadSuccess}
                        id={name + "_uploader"}
                        subID={subID}
                        uploadProgress={this.state.uploadProgress}
                        value={this.state.value}
                        {...props.fieldConfig}
                    />
                )}
            </div>
        );
    }
}

export default FieldFile;



// WEBPACK FOOTER //
// ./src/FieldFile.js